import React, { PureComponent } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { FHEContainer } from 'data/components';
import { Toastr } from 'data/common';
import FormIssue from './form';
import { getAllProjects } from '../../data/Projects/actions';
import { createIssue } from '../../data/Issues/actions';

class IssueAdd extends PureComponent {
    static propTypes = {
        getAllProjects: PropTypes.func.isRequired,
        environment: PropTypes.string.isRequired,
        createIssue: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        projectsInit: PropTypes.bool.isRequired
    };
    constructor(props) {
        super(props);
        const { projectsInit } = props;

        this.state = {
            loading: !projectsInit
        };
    }

    componentDidMount() {
        const { projectsInit } = this.props;
        if (!projectsInit) this.getAllProjects();
    }

    getAllProjects = () => {
        const { getAllProjects } = this.props;

        this.setState({ loading: true, error: null });

        getAllProjects()
            .then(() => this.setState({ loading: false, error: null }))
            .catch(err => {
                const message = Translator.translate(`api.message.${err.message}`);
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    createIssue = formIssue => {
        const { createIssue, history, environment } = this.props;

        return createIssue(formIssue)
            .then(data => {
                Toastr.success(Translator.translate('ticketsgit.issues.actions.createIssueSuccess'));
                return history.push({ pathname: `/${environment}/issues/${data.iid}/projects/${data.project_id}` });
            })
            .catch(error => {
                Toastr.error(Translator.translate('ticketsgit.issues.actions.createIssueError'));
                throw error;
            });
    };
    renderChildren = () => {
        return <FormIssue type="create" sendDataFunc={this.createIssue} />;
    };
    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getAllProjects} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    return {
        projectsInit: state.environments[props.environment].data.Projects.get('initialized')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getAllProjects, createIssue }, dispatch)
    )(IssueAdd)
);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/Issues/create.js